import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/file-based-exams/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const fileBasedExams = {
  getAll: apiPathFunc(pathBase),
} as const;
